let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3b3AF")).then(() => parcelRequire('eio5I'));